import React, { Fragment } from 'react'
import BackButton from 'components/BackButton'
import PageHeader from 'components/PageHeader'
import NavTabs from 'components/NavTabs'
import RouteAdminFeaturesGroupFeatures from './group/features'
import RouteAdminFeaturesGroupUsers from './group/users'
import RouteAdminFeaturesGroupsShowQuery from './group.query'
import styled from 'react-emotion'
import { Redirect, Route } from 'react-router-dom'
import { Query } from 'react-apollo'
import { spacer } from 'stylist'

const Container = styled.div`
  margin-top: ${spacer(4)};
`

const RouteAdminFeaturesGroupsShow = ({
  match: {
    path,
    params: { groupId },
    url
  }
}) => (
  <Query query={RouteAdminFeaturesGroupsShowQuery} variables={{ groupId }}>
    {({ loading, data: { group } }) => (
      <Fragment>
        <PageHeader columns="auto 1fr">
          <PageHeader.Icon>
            <BackButton to="/admin/features/groups" />
          </PageHeader.Icon>
          <PageHeader.Title>{loading ? '...' : group.name}</PageHeader.Title>
        </PageHeader>
        <article>
          <NavTabs>
            <NavTabs.Item to={`${url}/features`}>Features</NavTabs.Item>
            <NavTabs.Item to={`${url}/users`}>Users</NavTabs.Item>
          </NavTabs>
          <Container>
            <Route
              path={path}
              exact
              render={() => <Redirect to={`${url}/features`} />}
            />
            <Route
              path={`${path}/features`}
              component={RouteAdminFeaturesGroupFeatures}
            />
            <Route
              path={`${path}/users`}
              component={RouteAdminFeaturesGroupUsers}
            />
          </Container>
        </article>
      </Fragment>
    )}
  </Query>
)

export default RouteAdminFeaturesGroupsShow



// WEBPACK FOOTER //
// ./src/routes/admin/features/group.js